import React from "react";
import withSizePositionAngle from "components/withSizePositionAngle";


const _Vijver = () => {
    return (
        <g transform="translate(-2063.512873 -1137.969005)">
          <g transform="translate(32, 10)">
            <path opacity="1" fill="#96ccff" fillOpacity="1" stroke="none" strokeWidth="3.52046" strokeLinecap="round" strokeLinejoin="miter" strokeMiterlimit="4" strokeDasharray="none" strokeDashoffset="0" strokeOpacity="1" stopColor="#000000" stopOpacity="1" d="m 2089.7315,1132.8877 c 75.4982,-17.0318 222.664,15.4806 287.7121,17.4158 65.0479,1.935 97.9017,-4.8618 157.616,0 47.5351,3.8701 63.3788,62.2946 -175.1289,63.8578 -295.2176,1.9351 -407.7289,-50.2482 -270.1992,-81.2736 z" />
          </g>
        </g>
    );
}

const Vijver = withSizePositionAngle(_Vijver, 532.290943, 86.244628);

export default Vijver;
